/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_All_ResolutionsInputs */

const en_task_flow_item_all_resolutions = /** @type {(inputs: Task_Flow_Item_All_ResolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All resolutions`)
};

const pt_br2_task_flow_item_all_resolutions = /** @type {(inputs: Task_Flow_Item_All_ResolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as resoluções`)
};

/**
* | output |
* | --- |
* | "All resolutions" |
*
* @param {Task_Flow_Item_All_ResolutionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_all_resolutions = /** @type {((inputs?: Task_Flow_Item_All_ResolutionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_All_ResolutionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_all_resolutions(inputs)
	return pt_br2_task_flow_item_all_resolutions(inputs)
});